module.exports = __webpack_public_path__ + "img/list-ul.e75001f2.svg";